module.exports = __webpack_public_path__ + "img/sld_mppt_2_t1_b1.22781e91.svg";